import { render, staticRenderFns } from "./currencyList.vue?vue&type=template&id=caae6e20"
import script from "./currencyList.vue?vue&type=script&lang=js"
export * from "./currencyList.vue?vue&type=script&lang=js"
import style0 from "./currencyList.vue?vue&type=style&index=0&id=caae6e20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports